import { CalendarGridMode } from '../../../constants/calendarGrid'

export const CALENDAR_GRID_MODE_LABEL_KEY = {
  [CalendarGridMode.agenda]: 'Calendar.AgendaKey',
  [CalendarGridMode.day]: 'Calendar.DayKey',
  [CalendarGridMode.month]: 'Calendar.MonthKey',
  [CalendarGridMode.week]: 'Calendar.WeekKey',
}

export const QA_NAME_CALENDAR_GRID_MODE = {
  [CalendarGridMode.agenda]: 'calendarGridModeAgenda',
  [CalendarGridMode.day]: 'calendarGridModeDay',
  [CalendarGridMode.month]: 'calendarGridModeMonth',
  [CalendarGridMode.week]: 'calendarGridModeWeek',
}
